import { render, staticRenderFns } from "./DeleteBusModal.vue?vue&type=template&id=4fed53a4&"
import script from "./DeleteBusModal.vue?vue&type=script&lang=js&"
export * from "./DeleteBusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports